import * as React from 'react';

import SubcategoryModel from 'src/model/subcategory.model';
import { ICategoryContent } from 'src/model/category.model';

import './CategoriesDropdown.scss';
import { goToCategory, categoryUrl } from 'src/utils/navigation';
import installation from 'src/assets/installationIcon';
import applianceparts from 'src/assets/installationIcon';
import tools from 'src/assets/toolsIcon';
import hvac from 'src/assets/hvacIcon';
import filters from 'src/assets/filtersIcon';
import cleaners from 'src/assets/cleanersIcon';
import brushes from 'src/assets/brushesIcon';
import flashlights from 'src/assets/flashlightsIcon';
import aircondtioned from 'src/assets/airConditionerIcon';
import hoseIcon from 'src/assets/hoseIcon';
import protectiveIcon from 'src/assets/protective';
import applianceIcon from 'src/assets/appliance';
import smallapplianceIcon from 'src/assets/smallAppliances';
import garburatorIcon from 'src/assets/garburators';
import homeCareIcon from 'src/assets/homecare';
import trainingClassIcon from 'src/assets/trainingClassIcon';
import { env } from 'src/shared/env';
import i18n from 'src/translation/i18n';

interface ICategoriesDropdownProps {
  categories: ICategoryContent[];
  getCategories: () => void;
  t?: any;
  showSubcategories: boolean;
  subcategories: any;
  handleOpenSubCategory: (subcategory: any) => void;
  handleCloseAll: () => void;
  handleCloseSubMenu: () => void;
  handleOpenSubMenu: (category: any) => void;
  handleKeyDown?: (event: any) => void;


}

interface ICategoriesDropdownState {
  nColumns: number;
  floatingIsOpen: boolean;
  openId: string | null;
  categories: ICategoryContent[];
  showSubcategories: boolean;
  subcategories: any;
  subMenuTitle?: string;
  style?: object;
  showMenu?: boolean;
  show?: boolean;
  mounted?: boolean;
  menuTitle?: string;
  level?: number;
  goBackTitle?: string;
  categoriesDropdown?: any;
  flyMenuRef?: any;
  images?: any[];
  categoryIcon?: any[];
}

export class CategoriesDropdown extends React.Component<
  ICategoriesDropdownProps,
  ICategoriesDropdownState
> {
  public wrapperRef: HTMLDivElement | null = null;
  public categoriesDropdown: any;
  private flyMenuRef: any = null;
  public categories: ICategoryContent[];
  public showSubcategories: false;
  public subcategories: any;
  public subMenuTitle: string;
  public style: object;
  public menuTitle: string;
  public level: number;
  public goBackTitle: string;
  public mounted: boolean;
  public categoryIcon: any[];

  

  constructor(props: any) {    
    super(props);
    this.categoriesDropdown = React.createRef();
    this.flyMenuRef = React.createRef();
    this.showSubcategories = false;
    this.subcategories = [];
    this.subMenuTitle = '';

    this.menuTitle = '';
    this.level = 0;
    this.goBackTitle = '';
    this.mounted = false;
    

    this.state = {
      nColumns: 6,
      floatingIsOpen: false,
      openId: null,
      categories: this.props.categories || [],
      showSubcategories: false,
      subcategories: [],
      subMenuTitle: '',

      style: {
        transform: 'translateX(0vw)',
        transition: 'transform 200ms ease-in' },
      showMenu: false,
      show: false,
      mounted: true,
      menuTitle: '',
      level: 0,
      goBackTitle: '',
    };
    this.categoriesDropdown = React.createRef();
    this.categories = [];
  }

  public images = [
    { category: 'installation', imageSrc: installation },
    { category: 'appliance parts', imageSrc: applianceIcon },
    { category: 'tools', imageSrc: tools },
    { category: 'Tools & Protective Wear', imageSrc: protectiveIcon },
    { category: 'hvac', imageSrc: hvac },
    { category: 'Garbage Disposal', imageSrc: garburatorIcon },
    { category: 'filters', imageSrc: filters },
    { category: 'Cleaning & Home Care', imageSrc: homeCareIcon },
    { category: 'cleaners', imageSrc: cleaners },
    { category: 'cleaning', imageSrc: cleaners },
    { category: 'brushes', imageSrc: brushes },
    { category: 'Small Appliances & Parts', imageSrc: smallapplianceIcon },
    { category: 'flashlights', imageSrc: flashlights },
    { category: 'Hoses, Connectors & Fittings', imageSrc: hoseIcon },
    { category: 'a/c', imageSrc: aircondtioned },
    { category: 'Training Classes', imageSrc: trainingClassIcon }
  ];

  /* 
    openMenu
   */
  private openMenu = (category: any) => {
    // this.setState({ floatingIsOpen: true });
    category['menuState'] = 'opened';
    this.setState({ floatingIsOpen: true });
  };
  /* 
    closeMenu
   */
  private closeMenu = () => {
    // const arr = this.state.categories;
    // arr.forEach(cat => cat.menuState = '')
    this.categories.forEach(category => (category.menuState = ''));
    this.setState({ floatingIsOpen: false });
    // this.setState({ floatingIsOpen: false });
  };

  /* 
    handleMenuState
   */
  private handleMenuState = () => {
    // this.state.floatingIsOpen ? this.closeMenu() : this.openMenu();
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
    window.removeEventListener('resize', this.resize);
    document.removeEventListener("mousedown", this.handleClickOutsideFun);
  }

  private handleClickOutside = (e: any) => {
    if (this.flyMenuRef == null || this.flyMenuRef.contains == null) {
      return;
    }
    if (this.flyMenuRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    // this.setState({

    // });
    if (
      this.categoriesDropdown == null ||
      this.categoriesDropdown.contains == null
    ) {
      return;
    }
    if (this.categoriesDropdown.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      // showMenu: false,
      floatingIsOpen: false
    });
  };

  public componentDidMount() {
    this.props.getCategories();
    this.resize();
    window.addEventListener('resize', this.resize);
    document.addEventListener("mousedown", this.handleClickOutsideFun);
  }

  // public handleShowMenu = () => {
  //   this.setState(prevState => {
  //     return {
  //       showMenu: !prevState.showMenu
  //     };
  //   });
  // };

  public goToCategory = (categoryId: number, subcategoryId: number) => {
    goToCategory(categoryId, subcategoryId);
    this.closeMenu();
    this.setState({
      // showMenu: false
    });
  };

  private resize = () => {
    let nColumns = 6;
    if (window.innerWidth < 992) {
      nColumns = 4;
    }
    this.setState({
      ...this.state,
      nColumns
    });
  };

  public handleKeyDown= (event:any) => {
    if(event.keyCode === 13) {
      this.closeMenu();
    }
  }

  public handleCloseSubMenu = () => {
    this.setState({
      showSubcategories: false
    });
  };

   public handleOpenSubMenu = (category: any) => {
    this.setState({
      showSubcategories: true,
      subcategories: category.subcategories,
      subMenuTitle: category.name
    });
    this.handleOpenSubCategory(category);
  };

  public handleOpenSubMenu3 = () => {    
    this.setState({
      openId: null,
      floatingIsOpen: true
    });
  };

    public handleOpenSubCategory = (subcategory: any) => {
      if (subcategory.subcategories != null) {
        // Ignore categories
        return;
      }
      this.props.handleCloseAll();
      goToCategory(subcategory.category.id, subcategory.id);
    };

    public handleClickOutsideFun = (event: MouseEvent) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target as Node)) {
      // clicked outside -> close everything
      this.setState({ openId: null });
    } };

    public handleClick = (id: string,selectedCategoryName: string) => {  
     localStorage.setItem('applianceSelectedCategoryName',selectedCategoryName);    
     this.setState(
    prev => ({ openId: prev.openId === id ? null : id }),
    () => {
      if (this.state.openId === id) {
        const panel = document.getElementById(id);
        if (panel) { (panel as HTMLElement).scrollTop = 0; } // jump to top
      }
    }
  );  
  this.setState({ openId: id });
  };

  private renderCategory(category: ICategoryContent, index: number) {
    
    const menuState = this.state.floatingIsOpen ? 'opened' : 'closed';
    return (
      <React.Fragment key={`category-${category.id}`}>
        <div
          className="rp-category-dropdown--category"
          onMouseOut={this.closeMenu}
          onMouseOver={this.openMenu.bind(this, category)}
          onKeyDown={this.openMenu.bind(this, category)}
        >
          <div role="button"  tabIndex={0}
            // className="rp-category-dropdown--category-name"
            className={
              env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? 'rp-category-dropdown--category-name-ca'
                : 'rp-category-dropdown--category-name'
            }
            onClick= {() => {category.name === 'Training Classes'?this.goToCategory(62,62) :
            this.handleMenuState()}}
            
          >
            <img role="presentation" alt=""
              className="rp-category-icon"
              src={
                category.icon?category.icon:
                this.images.find(
                  img =>
                    img.category.toLowerCase() === category.name.toLowerCase()
                )?.imageSrc
              }
            />
            {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && category.frName!== null 
            ?category.frName
            :category.name}
          </div>
          
            {category.subcategories.length > 0 && (
              <>
            <div
              className={`rp-category-dropdown-subcategories--fly-menu  ${category.menuState}`}
              ref={ref => (this.flyMenuRef = ref)} 
            >
              <div className="rp-category-dropdown--subcategories" onKeyDown={this.handleKeyDown} >
                {category.subcategories
                  .slice()
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((subcategory: SubcategoryModel) => (
                    <div
                      className={`rp-category-dropdown--subcategories-name rp-category-mobile--category-with-arrow ${
                          this.state.openId === String(subcategory.id) ? "activeSubcategory" : ""
                        }`}
                      key={subcategory.id}

                      onClick={() => {
                        this.handleClick(String(subcategory.id), subcategory.name);
                        const hasChildren =
                          Array.isArray(subcategory.subcategories) &&
                          subcategory.subcategories.length > 0;

                        if (!hasChildren) {
                          this.goToCategory(subcategory.category.id, subcategory.id);
                        }
                      }} >
                      {Array.isArray(subcategory.subcategories) && subcategory.subcategories.length > 0 ? (
                        <a href="javascript:void(0);"
                        onClick={(e) => {
                          e.preventDefault(); // stop navigation
                          this.handleClick(String(subcategory.id),subcategory.name);
                        }}>
                        {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && subcategory.frName !== null
                          ? subcategory.frName
                          : subcategory.name}
                      </a>
                      ):(
                        <a href={subcategory.id === 62 ? '../training-classes/' : categoryUrl(subcategory.category.id, subcategory.id)}
                        onClick={() => this.goToCategory(subcategory.category.id, subcategory.id)}
                      >
                        {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && subcategory.frName !== null
                          ? subcategory.frName
                          : subcategory.name}
                      </a>
                      )
                      }
                      

                      {/* --- start level 3 flyout --- */}
                       {Array.isArray(subcategory.subcategories) && subcategory.subcategories.length > 0 && (
                        <>
                        <div className="arrow-div" onClick={() => this.handleOpenSubMenu(subcategory)}>
                            <button className="rpds-chevron-right submenu-arrow-icon" />
                          </div>
                        </>)}
                      {/*}
                      {Array.isArray(subcategory.subcategories) && subcategory.subcategories.length > 0 && (
                        <>
                          {/* was: handleOpenSubMenu(category) — should be the current subcategory */}
                          {/*}
                          <div className="arrow-div" onClick={() => this.handleOpenSubMenu(subcategory)}>
                            <button className="rpds-chevron-right submenu-arrow-icon" />
                          </div>

                          <div className="rp-level3-flyout">
                            <div className='flyout-parent-category'> {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && subcategory.frName !== null
                          ? subcategory.frName
                          : subcategory.name}</div>
                            {subcategory.subcategories
                              .slice()
                              .sort((a: SubcategoryModel, b: SubcategoryModel) => a.name.localeCompare(b.name))
                              .map((subcat: SubcategoryModel) => (
                                <div><a
                                  key={subcat.id}
                                  className="rp-level3-item"
                                  href={categoryUrl(subcat.category.id, subcat.id)}
                                  onClick={() => this.goToCategory(subcat.category.id, subcat.id)}
                                >
                                  {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && subcat.frName !== null
                                    ? subcat.frName
                                    : subcat.name}
                                </a></div>
                              ))}
                          </div>
                        </>
                      )} */}
                      {/* --- end level 3 flyout --- */}
                    </div>
                  ))}
              </div>
            </div>

            {/* third leve category new deisng */}
            {category.subcategories
                  .slice()
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((subcategory: SubcategoryModel) => ( <>
                    
              {Array.isArray(subcategory.subcategories) && subcategory.subcategories.length > 0 && (   
              
            <div className="rp-category-dropdown--subcategories-new" >                  
                  <div   className={` ${(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) ? "rp-level3-flyout-new-fr" : env.REACT_APP_BASE_ENVIRONMENT === 'US'?"rp-level3-flyout-new":"rp-level3-flyout-new-ca"}`}  id={String(subcategory.id)} key={subcategory.id} style={{ display: this.state.openId === String(subcategory.id) ? category.menuState === "" ? "none":"block" : "none" }}>            
              <>   
                 <div>
                    <div className="flyout-parent-category"> {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && subcategory.frName !== null
                          ? subcategory.frName
                          : subcategory.name}</div>
                          <div className="child-level3">
                          {subcategory.subcategories
                              .slice()
                              .sort((a: SubcategoryModel, b: SubcategoryModel) => a.name.localeCompare(b.name))
                              .map((subcat: SubcategoryModel) => (
                                <div className="rp-level3-row" onClick={() => {
                                    this.goToCategory(subcat.category.id, subcat.id);
                                    this.handleOpenSubMenu3();
                                  }} ><a
                                  key={subcat.id}
                                  className="rp-level3-item"
                                  href={categoryUrl(subcat.category.id, subcat.id)}
                                  onClick={() => {
                                    this.goToCategory(subcat.category.id, subcat.id);
                                    this.handleOpenSubMenu3();
                                  }}
                                >
                                  {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && subcat.frName !== null
                                    ? subcat.frName
                                    : subcat.name}
                                </a></div>
                         ))}</div>
                </div>             
            </>             
            </div></div>)} 
            </>
            ))} 
          
          </>
            
          )}

          

          
        </div>
      </React.Fragment>
    );
  }

  private renderMenu() {
    // Order categories according to orderNumber
    this.categories = this.props.categories.sort(
      (a: ICategoryContent, b: ICategoryContent) => {
        return a.orderNumber - b.orderNumber;
      }
    );
    // this.categories.forEach(category => category.image = 'sadsad')

    const columns: ICategoryContent[][] = [];
    for (let i = 0; i < this.state.nColumns; i++) {
      columns.push([]);
    }

    return (
      <React.Fragment>
        <div className="rp-category-div">
          {this.props.categories.length > 0
            ? this.categories.map((column: ICategoryContent, i) => (
                <div className="category-section" key={`column-${i}`}>
                  {this.renderCategory(column, i)}
                </div>
              ))
            : i18n.t('common.noCategoriesFound')}
        </div>
      </React.Fragment>
    );
  }

  public render() {
    return <div>{this.renderMenu()}</div>;
  }
}

export default CategoriesDropdown;
